import actions from "./packages.actions";

export default {
  namespaced: true,
  actions,
};
